var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseApiService } from "./services/BaseApiService";
import { AusmashDateQuery } from "./types/AusmashDateQuery";
export default class AusmashService extends BaseApiService {
    constructor(token, apiUrl = "https://api.ausmash.com.au") {
        super(token, apiUrl);
        this.updateToken = (token) => {
            this.token = token;
        };
        this.Account = {
            login: (model) => __awaiter(this, void 0, void 0, function* () {
                const x = yield this.post("/account/login", model);
                if (x.Success) {
                    this.updateToken(x.Data.Key);
                }
                return x;
            }),
        };
        this.Characters = {
            getCharacters: () => {
                return this.get("/characters");
            },
            getCharacterById: (id) => {
                return this.get(`/characters/${id}`);
            },
            getCharactersByGameId: (id) => {
                return this.get(`/characters/bygame/${id}`);
            },
            getResults: (id) => {
                return this.get(`/characters/${id}/results`);
            },
            getMatches: (id) => {
                return this.get(`/characters/${id}/matches`);
            },
            getWinningMatches: (id) => {
                return this.get(`/characters/${id}/matcheswins`);
            },
            getLosingMatches: (id) => {
                return this.get(`/characters/${id}/matcheslosses`);
            },
            getVideos: (id) => {
                return this.get(`/characters/${id}/videos`);
            },
            getPlayers: (id) => {
                return this.get(`/characters/${id}/players`);
            },
        };
        this.Compare = {
            getStatsById: (gameId, player1Id, player2Id, dateOptions) => {
                return this.get(`/compare/${gameId}/${player1Id}/${player2Id}/stats${AusmashDateQuery.toQueryString(dateOptions)}`);
            },
            getStatsByText: (gameShort, player1RegionShort, player1Name, player2RegionShort, player2Name, dateOptions) => {
                return this.get(`/compare/${gameShort}/${player1RegionShort}/${player1Name}/${player2RegionShort}/${player2Name}/stats${AusmashDateQuery.toQueryString(dateOptions)}`);
            },
            getMatchesById: (gameId, player1Id, player2Id, dateOptions) => {
                return this.get(`/compare/${gameId}/${player1Id}/${player2Id}/matches${AusmashDateQuery.toQueryString(dateOptions)}`);
            },
            getMatchesByText: (gameShort, player1RegionShort, player1Name, player2RegionShort, player2Name, dateOptions) => {
                return this.get(`/compare/${gameShort}/${player1RegionShort}/${player1Name}/${player2RegionShort}/${player2Name}/matches${AusmashDateQuery.toQueryString(dateOptions)}`);
            },
            getCharactersById: (gameId, player1Id, player2Id, dateOptions) => {
                return this.get(`/compare/${gameId}/${player1Id}/${player2Id}/characters${AusmashDateQuery.toQueryString(dateOptions)}`);
            },
            getCharactersByText: (gameShort, player1RegionShort, player1Name, player2RegionShort, player2Name, dateOptions) => {
                return this.get(`/compare/${gameShort}/${player1RegionShort}/${player1Name}/${player2RegionShort}/${player2Name}/characters${AusmashDateQuery.toQueryString(dateOptions)}`);
            },
            getVideosById: (gameId, player1Id, player2Id, dateOptions) => {
                return this.get(`/compare/${gameId}/${player1Id}/${player2Id}/videos${AusmashDateQuery.toQueryString(dateOptions)}`);
            },
            getVideosByText: (gameShort, player1RegionShort, player1Name, player2RegionShort, player2Name, dateOptions) => {
                return this.get(`/compare/${gameShort}/${player1RegionShort}/${player1Name}/${player2RegionShort}/${player2Name}/videos${AusmashDateQuery.toQueryString(dateOptions)}`);
            },
            getRankingsById: (gameId, player1Id, player2Id, dateOptions) => {
                return this.get(`/compare/${gameId}/${player1Id}/${player2Id}/rankings${AusmashDateQuery.toQueryString(dateOptions)}`);
            },
            getRankingsByText: (gameShort, player1RegionShort, player1Name, player2RegionShort, player2Name, dateOptions) => {
                return this.get(`/compare/${gameShort}/${player1RegionShort}/${player1Name}/${player2RegionShort}/${player2Name}/rankings${AusmashDateQuery.toQueryString(dateOptions)}`);
            },
            getResultsById: (gameId, player1Id, player2Id, dateOptions) => {
                return this.get(`/compare/${gameId}/${player1Id}/${player2Id}/results${AusmashDateQuery.toQueryString(dateOptions)}`);
            },
            getResultsByText: (gameShort, player1RegionShort, player1Name, player2RegionShort, player2Name, dateOptions) => {
                return this.get(`/compare/${gameShort}/${player1RegionShort}/${player1Name}/${player2RegionShort}/${player2Name}/results${AusmashDateQuery.toQueryString(dateOptions)}`);
            },
            getWinRatesById: (gameId, player1Id, player2Id, dateOptions) => {
                return this.get(`/compare/${gameId}/${player1Id}/${player2Id}/winrates${AusmashDateQuery.toQueryString(dateOptions)}`);
            },
            getWinRatesByText: (gameShort, player1RegionShort, player1Name, player2RegionShort, player2Name, dateOptions) => {
                return this.get(`/compare/${gameShort}/${player1RegionShort}/${player1Name}/${player2RegionShort}/${player2Name}/winrates${AusmashDateQuery.toQueryString(dateOptions)}`);
            },
        };
        this.Elo = {
            getElo: () => {
                return this.get("/elo");
            },
            getEloByGameId: (id) => {
                return this.get(`/elo/game/${id}`);
            },
        };
        this.Events = {
            getResults: (id) => {
                return this.get(`/events/${id}/results`);
            },
            getMatches: (id) => {
                return this.get(`/events/${id}/matches`);
            },
            getVideos: (id) => {
                return this.get(`/events/${id}/videos`);
            },
        };
        this.Games = {
            getGames: () => {
                return this.get("/games");
            },
            getGameById: (id) => {
                return this.get(`/games/${id}`);
            },
        };
        this.Players = {
            getPlayers: () => {
                return this.get("/players");
            },
            getPlayerByText: (region, name) => {
                return this.get(`/players/find/${name}/${region}`);
            },
            searchPlayers: (query) => {
                const params = new URLSearchParams({
                    q: query,
                });
                return this.get(`/players/search?${params.toString()}`);
            },
            getPlayerByRegionText: (region) => {
                return this.get(`/players/byregion/${region}`);
            },
            getPlayerById: (id) => {
                return this.get(`/players/${id}`);
            },
            getElo: (id) => {
                return this.get(`/players/${id}/elo`);
            },
            getTrueSkill: (id) => {
                return this.get(`/players/${id}/trueskill`);
            },
            getResults: (id, dateOptions) => {
                return this.get(`/players/${id}/results${AusmashDateQuery.toQueryString(dateOptions)}`);
            },
            getMatches: (id, dateOptions) => {
                return this.get(`/players/${id}/matches${AusmashDateQuery.toQueryString(dateOptions)}`);
            },
            getRankings: (id, dateOptions) => {
                return this.get(`/players/${id}/rankings${AusmashDateQuery.toQueryString(dateOptions)}`);
            },
            getWinRates: (playerId, gameId, dateOptions) => {
                return this.get(`/players/${playerId}/winrates/${gameId}${AusmashDateQuery.toQueryString(dateOptions)}`);
            },
            getCharacters: (playerId, gameId) => {
                return this.get(`/players/${playerId}/characters/${gameId}`);
            },
            getVideos: (id, dateOptions) => {
                return this.get(`/players/${id}/videos${AusmashDateQuery.toQueryString(dateOptions)}`);
            },
            getVideosByCharacterId: (playerId, characterId, dateOptions) => {
                return this.get(`/players/${playerId}/videos/${characterId}${AusmashDateQuery.toQueryString(dateOptions)}`);
            },
        };
        this.Pocket = {
            getGames: () => {
                return this.get("/pocket/games");
            },
            getElo: (id) => {
                return this.get(`/pocket/elo/${id}`);
            },
            getInternationalPlayers: (id) => {
                return this.get(`/pocket/players/international/${id}`);
            },
            getPlayer: (playerId, gameId) => {
                return this.get(`/pocket/player/${playerId}/${gameId}`);
            },
            getWinRates: (playerId, gameId) => {
                return this.get(`/pocket/player/winrates/${playerId}/${gameId}`);
            },
            getResults: (playerId, gameId) => {
                return this.get(`/pocket/player/results/${playerId}/${gameId}`);
            },
            getVideos: (playerId, gameId) => {
                return this.get(`/pocket/player/videos/${playerId}/${gameId}`);
            },
            getMatches: (playerId, gameId) => {
                return this.get(`/pocket/player/matches/${playerId}/${gameId}`);
            },
        };
        this.Rankings = {
            getRankings: () => {
                return this.get("/rankings");
            },
            getRankingsBySequenceId: (id) => {
                return this.get(`/rankings/bysequence/${id}`);
            },
            getRankingsByRegionShort: (region) => {
                return this.get(`/rankings/byregion/${region}`);
            },
            getRankingsByGameId: (id) => {
                return this.get(`/rankings/bygame/${id}`);
            },
            getRankingsByGameAndRegion: (gameId, regionShort) => {
                return this.get(`/rankings/bygameandregion/${gameId}/${regionShort}`);
            },
            getActiveRankings: () => {
                return this.get("/rankings/active");
            },
            getRankingById: (id) => {
                return this.get(`/rankings/${id}`);
            },
        };
        this.RankingSequences = {
            getRankingSequences: () => {
                return this.get("/rankingsequences");
            },
        };
        this.Regions = {
            getRegions: () => {
                return this.get("/regions");
            },
        };
        this.Series = {
            getSeries: () => {
                return this.get("/series");
            },
        };
        this.Tourneys = {
            getTourneys: (dateOptions) => {
                return this.get(`/tourneys${AusmashDateQuery.toQueryString(dateOptions)}`);
            },
            getTourneyById: (id) => {
                return this.get(`/tourneys/${id}`);
            },
            searchTourneys: (query) => {
                const params = new URLSearchParams({
                    q: query,
                });
                return this.get(`/tourneys/search?${params.toString()}`);
            },
            getUpcomingTourneys: (dateOptions) => {
                return this.get(`/tourneys/upcoming${AusmashDateQuery.toQueryString(dateOptions)}`);
            },
            getTourneysWithResults: (dateOptions) => {
                return this.get(`/tourneys/withresults${AusmashDateQuery.toQueryString(dateOptions)}`);
            },
            getTourneysByRegionShort: (region, dateOptions) => {
                return this.get(`/tourneys/byregion/${region}${AusmashDateQuery.toQueryString(dateOptions)}`);
            },
            getTourneysBySeriesId: (id, dateOptions) => {
                return this.get(`/tourneys/byseries/${id}${AusmashDateQuery.toQueryString(dateOptions)}`);
            },
        };
        this.TrueSkill = {
            getTrueSkill: () => {
                return this.get("/trueskill");
            },
            getTrueSkillByGameId: (id) => {
                return this.get(`/trueskill/game/${id}`);
            },
        };
    }
}
export * from "./models/api/_index";
export * from "./models/account/_index";
export * from "./models/characters/_index";
export * from "./models/compare/_index";
export * from "./models/elo/AusmashEloGame";
export * from "./models/elo-details/AusmashEloDetailIndexItem";
export * from "./models/games/_index";
export * from "./models/players/_index";
export * from "./models/player-win-rates/AusmashPlayerWinRateIndexItem";
export * from "./models/player-characters/AusmashPlayerCharactersIndexItem";
export * from "./models/pocket/_index";
export * from "./models/ranking-players/AusmashRankingPlayerIndexItem";
export * from "./models/ranking-sequences/AusmashRankingSequenceIndexItem";
export * from "./models/rankings/_index";
export * from "./models/tourneys/_index";
export * from "./models/tourney-events/AusmashTourneyEventIndexItem";
export * from "./models/tourney-event-matches/AusmashTourneyEventMatchIndexItem";
export * from "./models/tourney-event-results/AusmashTourneyEventResultIndexItem";
export * from "./models/tourney-series/AusmashTourneySeriesIndexItem";
export * from "./models/regions/AusmashRegionIndexItem";
export * from "./models/trueskill/AusmashTrueSkillGame";
export * from "./models/trueskill-details/AusmashTrueSkillDetailIndexItem";
export * from "./models/videos/AusmashVideoIndexItem";
